var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSinglePageDocument = function SvgSinglePageDocument(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.313 10h7.374l-7.375-7.313V10Zm4 6.688V14H5.688v2.688h10.625Zm0 5.312v-2.688H5.688V22h10.625ZM13.688.687l8 8v16c0 .709-.271 1.334-.813 1.875-.542.5-1.167.75-1.875.75H3c-.708 0-1.333-.25-1.875-.75-.542-.541-.813-1.166-.813-1.875L.376 3.313c0-.708.25-1.312.75-1.812C1.667.958 2.292.687 3 .687h10.688Z",
    fill: "#5331C6"
  })));
};
export default SvgSinglePageDocument;